import React from 'react';
import './DichVuCong.css';

function  DichVuCong () {
   

        return (
            <div>
                <div className="">
    {/* <!-- Header Breadcrumb --> */}
    <div className="dich-vu-cong-breadcrumb">
        <span>Trang chủ</span>
        <span className="dich-vu-cong-dot">›</span>
        <span>Dịch vụ công</span>
    </div>

    {/* <!-- Header --> */}
    <div className="dich-vu-cong-header">
        <h2>Dịch vụ công</h2>
        <p>
            Cung cấp thông tin và dịch vụ công trực tuyến cho doanh nghiệp,
            tổ chức và cá nhân
        </p>
    </div>

    {/* <!-- Top Statistic Cards --> */}
    <div className="dich-vu-cong-top-cards">
        <div className="dich-vu-cong-stat-card">
            <div className="dich-vu-cong-stat-icon blue">
               <i className="fa-solid fa-file-lines"></i>
            </div>

            <div className="dich-vu-cong-stat-content">
                <h5>Tổng số dịch vụ</h5>
                <h3>125</h3>
                <p><i className="fa-solid fa-plus icon-dich-vu-cong-share"></i> 12 dịch vụ so với tháng trước</p>

                <a href="/">
                    Xem chi tiết <i className="fa-solid fa-arrow-right dich-vu-cong-detail-share"></i>
                </a>
            </div>
        </div>

        <div className="dich-vu-cong-stat-card">
            <div className="dich-vu-cong-stat-icon green">
             {/* <i className="fa-solid fa-file-contract"></i> */}
             <i className="fa-solid fa-file-circle-check"></i>
            </div>

            <div className="dich-vu-cong-stat-content">
                <h5>Hồ sơ đã tiếp nhận</h5>
                <h3>2.432</h3>
                <p><i className="fa-solid fa-plus icon-dich-vu-cong-share"></i> 18,45% so với tháng trước</p>

                <a href="/">
                    Xem chi tiết <i className="fa-solid fa-arrow-right dich-vu-cong-detail-share"></i>
                </a>
            </div>
        </div>

        <div className="dich-vu-cong-stat-card">
            <div className="dich-vu-cong-stat-icon orange">
                <i className="fa fa-hourglass-half"></i>
            </div>

            <div className="dich-vu-cong-stat-content">
                <h5>Hồ sơ đang xử lý</h5>
                <h3>687</h3>
                <p> <i className="fa-solid fa-plus icon-dich-vu-cong-share"></i> 5,21% so với tháng trước</p>

                <a href="/">
                    Xem chi tiết <i className="fa-solid fa-arrow-right dich-vu-cong-detail-share"></i>
                </a>
            </div>
        </div>

        <div className="dich-vu-cong-stat-card">
            <div className="dich-vu-cong-stat-icon purple">
              <i className="fa-solid fa-clipboard-check"></i>
            </div>

            <div className="dich-vu-cong-stat-content">
                <h5>Hồ sơ đã hoàn thành</h5>
                <h3>1.672</h3>
                <p><i className="fa-solid fa-plus icon-dich-vu-cong-share"></i> 20,35% so với tháng trước</p>

                <a href="/">
                    Xem chi tiết <i className="fa-solid fa-arrow-right dich-vu-cong-detail-share"></i>
                </a>
            </div>
        </div>

        <div className="dich-vu-cong-stat-card">
            <div className="dich-vu-cong-stat-icon red">
              <i className="fa-regular fa-circle-xmark"></i>
            </div>

            <div className="dich-vu-cong-stat-content">
                <h5>Hồ sơ quá hạn</h5>
                <h3>73</h3>
                <p> <i className="fa-solid fa-plus icon-dich-vu-cong-share"></i> 8 hồ sơ so với tháng trước</p>

                <a href="/">
                    Xem chi tiết <i className="fa-solid fa-arrow-right dich-vu-cong-detail-share"></i>
                </a>
            </div>
        </div>
    </div>

    {/* <!-- Main Content --> */}
    <div className="dich-vu-cong-main-grid">

        {/* <!-- Left --> */}
        <div className="dich-vu-cong-left">

            {/* <!-- Featured Services --> */}
            <div className="dich-vu-cong-card">
                <div className="dich-vu-cong-card-header">
                    <h4>Dịch vụ công nổi bật</h4>

                    <a href="/">Xem tất cả <i className="fa-solid fa-arrow-right dich-vu-cong-detail-share"></i></a>
                </div>

                <div className="dich-vu-cong-feature-grid">

                    <div className="dich-vu-cong-feature-item">
                        <div className='main-dich-vu-cong'>
                            <div className="dich-vu-cong-feature-icon purple">
                             <i className="fa-solid fa-file-lines"></i>
                        </div>

                        <div>
                            <h5>Cấp Giấy chứng nhận đăng ký đầu tư</h5>

                            <p>
                                Thủ tục cấp mới Giấy chứng nhận đăng ký đầu tư
                                trong KCN
                            </p>
                        </div>

                        </div>
                            <a href="/">Nộp hồ sơ <i className="fa-solid fa-arrow-right dich-vu-cong-detail-share"></i></a>
                    </div>

                    <div className="dich-vu-cong-feature-item">
                        <div className='main-dich-vu-cong'>

                        <div className="dich-vu-cong-feature-icon green">
                         <i className="fa-solid fa-building"></i>
                        </div>

                        <div>
                            <h5>Cấp Giấy chứng nhận đăng ký doanh nghiệp</h5>

                            <p>
                                Thủ tục cấp mới Giấy chứng nhận đăng ký doanh nghiệp
                            </p>
                        </div>

                        </div>
                            <a href="/">Nộp hồ sơ <i className="fa-solid fa-arrow-right dich-vu-cong-detail-share"></i></a>
                    </div>

                    <div className="dich-vu-cong-feature-item">
                        <div className='main-dich-vu-cong'>
                            
                        <div className="dich-vu-cong-feature-icon orange">
                          <i className="fa-regular fa-file-lines"></i>
                        </div>

                        <div>
                            <h5>Cấp giấy phép xây dựng</h5>

                            <p>
                                Thủ tục cấp giấy phép xây dựng trong KCN
                            </p>
                        </div>

                        </div>
                            <a href="/" className='nop-ho-so'>Nộp hồ sơ →</a>
                    </div>

                    <div className="dich-vu-cong-feature-item">
                        <div className='main-dich-vu-cong'>

                        <div className="dich-vu-cong-feature-icon pink">
                            {/* <i className="fa fa-leaf"></i> */}
                            <i className="fa-solid fa-leaf"></i>
                        </div>

                        <div>
                            <h5>Xác nhận báo cáo bảo vệ môi trường</h5>

                            <p>
                                Thủ tục xác nhận báo cáo bảo vệ môi trường
                            </p>
                        </div>

                        </div>
                            <a href="/">Nộp hồ sơ <i className="fa-solid fa-arrow-right dich-vu-cong-detail-share"></i></a>
                    </div>

                    <div className="dich-vu-cong-feature-item">
                        <div className='main-dich-vu-cong'>

                        <div className="dich-vu-cong-feature-icon cyan">
                            <i className="fa fa-users"></i>
                        </div>

                        <div>
                            <h5>Cấp thẻ ra vào khu công nghiệp</h5>

                            <p>
                                Thủ tục cấp mới, cấp lại thẻ ra vào khu công nghiệp
                            </p>
                        </div>
                        </div>

                            <a href="/">Nộp hồ sơ <i className="fa-solid fa-arrow-right dich-vu-cong-detail-share"></i></a>
                    </div>

                    <div className="dich-vu-cong-feature-item">
                        <div className='main-dich-vu-cong'>

                        <div className="dich-vu-cong-feature-icon magenta">
                           <i className="fa-solid fa-truck"></i>
                        </div>

                        <div>
                            <h5>Đăng ký phương tiện vận tải</h5>

                            <p>
                                Thủ tục đăng ký phương tiện vận tải ra vào khu công nghiệp
                            </p>
                        </div>

                        </div>
                            <a href="/">Nộp hồ sơ <i className="fa-solid fa-arrow-right dich-vu-cong-detail-share"></i></a>
                    </div>
                </div>
            </div>

            {/* <!-- Chart Section --> */}
            <div className="dich-vu-cong-chart-grid">

                {/* <!-- Doughnut --> */}
                <div className="dich-vu-cong-card">
                    <div className="dich-vu-cong-card-header">
                        <h4>Tình hình xử lý hồ sơ</h4>

                        <input className="dich-vu-cong-select" placeholder='Tháng 05/2026'>
                            {/* <option></option> */}
                        </input>
                    </div>

                    <div className="dich-vu-cong-circle-chart">
                        <div className="dich-vu-cong-circle-center">
                            <span>Tổng hồ sơ</span>
                            <h3>2.432</h3>
                        </div>
                    </div>

                    <ul className="dich-vu-cong-chart-legend">
                        <li><span className="blue"></span>Đã tiếp nhận: 2.432 (100%)</li>
                        <li><span className="orange"></span>Đang xử lý: 687 (28,24%)</li>
                        <li><span className="green"></span>Đã hoàn thành: 1.672 (68,49%)</li>
                        <li><span className="red"></span>Quá hạn: 73 (3,00%)</li>
                    </ul>

                    <a href="/" className="dich-vu-cong-view-more">
                        Xem báo cáo chi tiết <i className="fa-solid fa-arrow-right dich-vu-cong-detail-share"></i>
                    </a>
                </div>

                {/* <!-- Line Chart --> */}
                <div className="dich-vu-cong-card">
                    <div className="dich-vu-cong-card-header">
                        <h4>Biểu đồ hồ sơ theo ngày</h4>

                        <select className="dich-vu-cong-select">
                            <option>7 ngày qua</option>
                        </select>
                    </div>

                    <div className="dich-vu-cong-line-chart">

                        {/* <!-- Grid lines --> */}
                        <div className="dich-vu-cong-grid-line line-1"></div>
                        <div className="dich-vu-cong-grid-line line-2"></div>
                        <div className="dich-vu-cong-grid-line line-3"></div>
                        <div className="dich-vu-cong-grid-line line-4"></div>

                        {/* <!-- Y axis --> */}
                        <div className="dich-vu-cong-y-axis">
                            <span>500</span>
                            <span>400</span>
                            <span>300</span>
                            <span>200</span>
                            <span>100</span>
                            <span>0</span>
                        </div>

                        {/* <!-- Chart SVG --> */}
                        <svg viewBox="0 0 700 320">

                            {/* <!-- Blue --> */}
                            <polyline
                                points="40,160 130,120 220,150 310,110 400,90 490,140 580,60"
                                className="dich-vu-cong-line blue-line"
                            />

                            {/* <!-- Orange --> */}
                            <polyline
                                points="40,210 130,200 220,190 310,140 400,150 490,180 580,160"
                                className="dich-vu-cong-line orange-line"
                            />

                            {/* <!-- Green --> */}
                            <polyline
                                points="40,250 130,240 220,260 310,230 400,220 490,240 580,210"
                                className="dich-vu-cong-line green-line"
                            />

                            {/* <!-- Red --> */}
                            <polyline
                                points="40,290 130,285 220,280 310,275 400,278 490,282 580,276"
                                className="dich-vu-cong-line red-line"
                            />
                        </svg>

                        {/* <!-- X axis --> */}
                        <div className="dich-vu-cong-x-axis">
                            <span>06/05</span>
                            <span>07/05</span>
                            <span>08/05</span>
                            <span>09/05</span>
                            <span>10/05</span>
                            <span>11/05</span>
                            <span>12/05</span>
                        </div>

                        {/* <!-- Legend --> */}
                        <div className="dich-vu-cong-chart-bottom-legend">
                            <div><span className="blue"></span>Tiếp nhận</div>
                            <div><span className="orange"></span>Đang xử lý</div>
                            <div><span className="green"></span>Hoàn thành</div>
                            <div><span className="red"></span>Quá hạn</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* <!-- Right --> */}
        <div className="dich-vu-cong-right">

            {/* <!-- Notification --> */}
            <div className="dich-vu-cong-card">
                <div className="dich-vu-cong-card-header">
                    <h4>Thông báo & Hướng dẫn</h4>

                    <a href="/">Xem tất cả <i className="fa-solid fa-arrow-right dich-vu-cong-detail-share"></i></a>
                </div>

                <div className="dich-vu-cong-notify-item">
                    <div className="dich-vu-cong-notify-icon blue">
                        <i className="fa fa-bullhorn"></i>
                    </div>

                    <div>
                        <h5>
                            Thông báo cập nhật quy trình giải quyết thủ tục
                        </h5>

                        <p>
                            Áp dụng quy trình mới đối với hồ sơ thủ tục hành chính
                            trong KCN từ ngày 10/05/2026
                        </p>

                        <span>10/05/2026</span>
                    </div>
                </div>

                <div className="dich-vu-cong-notify-item">
                    <div className="dich-vu-cong-notify-icon green">
                        <i className="fa fa-book"></i>
                    </div>

                    <div>
                        <h5>Hướng dẫn nộp hồ sơ trực tuyến</h5>

                        <p>
                            Hướng dẫn chi tiết các bước nộp hồ sơ trực tuyến
                            trên hệ thống
                        </p>

                        <span>08/05/2026</span>
                    </div>
                </div>

                <div className="dich-vu-cong-notify-item">
                    <div className="dich-vu-cong-notify-icon orange">
                        <i className="fa fa-exclamation-triangle"></i>
                    </div>

                    <div>
                        <h5>Lịch bảo trì hệ thống</h5>

                        <p>
                            Hệ thống sẽ bảo trì định kỳ vào ngày 15/05/2026
                            từ 22:00 đến 02:00 sáng hôm sau
                        </p>

                        <span>07/05/2026</span>
                    </div>
                </div>

                <div className="dich-vu-cong-notify-item">
                    <div className="dich-vu-cong-notify-icon purple">
                        <i className="fa fa-info-circle"></i>
                    </div>

                    <div>
                        <h5>Câu hỏi thường gặp</h5>

                        <p>
                            Tổng hợp các câu hỏi thường gặp khi sử dụng
                            dịch vụ công trực tuyến
                        </p>

                        <span>05/05/2026</span>
                    </div>
                </div>
            </div>

            {/* <!-- Search --> */}
            <div className="dich-vu-cong-card">
                <h4 className="dich-vu-cong-search-title">
                    Tra cứu hồ sơ
                </h4>

                <input
                    type="text"
                    className="dich-vu-cong-input"
                    placeholder="Nhập mã hồ sơ, tên thủ tục..."
                />

                <div className="dich-vu-cong-search-advanced">
                    <h5>Tra cứu nâng cao</h5>

                    <div className="dich-vu-cong-search-row">
                        <select className="dich-vu-cong-select">
                            <option>Chọn trạng thái</option>
                        </select>

                        <select className="dich-vu-cong-select">
                            <option>Chọn dịch vụ công</option>
                        </select>
                    </div>

                    <div className="dich-vu-cong-search-row">
                        <input
                            type="date"
                            className="dich-vu-cong-input"
                        />

                        <input
                            type="date"
                            className="dich-vu-cong-input"
                        />
                    </div>

                    <button className="dich-vu-cong-search-btn">
                        Tra cứu
                    </button>
                </div>
            </div>
        </div>
    </div>

    {/* <!-- Bottom Steps --> */}
    <div className="dich-vu-cong-bottom-steps">

        <div className="dich-vu-cong-step-card">
            <div className="dich-vu-cong-step-number">
                <i className="fa-regular fa-user"></i>
            </div>

            <div>
                <h5>1. Đăng ký/Đăng nhập</h5>
                <p>Đăng ký tài khoản hoặc đăng nhập hệ thống</p>
            </div>
        </div>

        <div className="dich-vu-cong-step-card">
            <div className="dich-vu-cong-step-number">
                <i class="fa-solid fa-magnifying-glass"></i>
            </div>

            <div>
                <h5>2. Chọn dịch vụ công</h5>
                <p>Tìm kiếm và chọn dịch vụ công cần thực hiện</p>
            </div>
        </div>

        <div className="dich-vu-cong-step-card">
            <div className="dich-vu-cong-step-number">
                <i className="fa-regular fa-file-lines"></i>
            </div>

            <div>
                <h5>3.Nộp hồ sơ trực tuyến</h5>
                <p>Điền thông tin và đính kèm hồ sơ theo yêu cầu</p>
            </div>
        </div>

        <div className="dich-vu-cong-step-card">
            <div className="dich-vu-cong-step-number">
                <i className="fa-regular fa-clock"></i>
            </div>

            <div>
                <h5>4. Theo dõi xử lý</h5>
                <p>Theo dõi tiến trình xử lý hồ sơ trực tuyến</p>
            </div>
        </div>

        <div className="dich-vu-cong-step-card">
            <div className="dich-vu-cong-step-number">
             <i className="fa-regular fa-circle-down"></i>
            </div>

            <div>
                <h5>5. Nhận kết quả</h5>
                <p>Nhận kết quả giải quyết qua hệ thống</p>
            </div>
        </div>
    </div>
</div>
            </div>
            
        );
    }


export default DichVuCong;